const enUs = {
    /* 00.General */
    'general.copyright': 'Coffee Management © 2019 All Rights Reserved.',
    'general.refresh': 'Refresh Lists',
    'general.btn-update': 'Update',
    'general.btn-update-count': 'Update Count',
    'general.btn-add': 'Add',
    'general.btn-order': 'Order now!',
    'general.btn-order-preview': 'View product',
    'general.btn-create-make-product': 'Tạo định lượng',
    'general.btn-update-make-product': 'Cập nhật định lượng',
    'general.info': 'INFOMATION',
    'general.setting': 'SETTING',
    'general.function': 'FUNCTION',
    timeCreated: 'Time created',
    'print.cashier': 'Cashier',
    'print.invoice': 'Invoice',
    'print.name-product': 'Name',
    'print.quantity': 'Quantity',
    'print.price': 'Price',
    'print.total-price': 'Total',
    'print.discount': 'Discount',
    'print.tax': 'Tax',
    'print.fee-other': 'Fee',
    'print.amount-to-pay': 'Amount to be paid',
    'print.info-bill': 'Billing Infomation',
    'print.thank-you': 'Thank you very much!',
    'print.copy-right': 'Copyright of vmass.vn.',

    /* 01.Order */
    'order.to-pending': 'to Kitchen',
    'order.to-done': 'Move Pay',
    'order.done': 'Done',
    'order.to-refund': 'Refund',
    'order.to-change': 'Change',
    'order.to-bill-draft': 'Print provisional invoices',
    'order.to-bill': 'Print bill',
    'order.to-end': 'Completed',
    'order.print-bill': 'Print bill',
    'order.to-excel': 'Download Excel',
    'order.to-destroy': 'Destroy',
    'order.transfer-table': 'Transfer table',
    'order.to-bill-now': 'Print',
    'order.to-bill-all': 'Print All',
    'order.open-menu': 'Add product',
    'order.search': 'Search for invoices',
    'order.list-product-in-table': 'List products in the table',

    /* 02. Profile */
    'company-uuid': 'Store code',
    'company-name': 'Name of the store',
    'profile.fullname': 'Fullname',
    'profile.username': 'Username',
    'profile.email': 'Email',
    'profile.address': 'Address',
    'profile.description': 'Description',
    'profile.avatar': 'Avatar',
    'profile.company-address': 'Company Address',
    'profile.company-website': 'Website',
    'profile.company-logo': 'Logo Store',
    'profile.company-image': 'Cover photo of the store',
    'profile.company-start-time': 'Open time',
    'profile.company-end-time': 'Close time',
    'profile.company-menu-hash': 'Store menu code',
    'profile.company-menu-hash-create': 'Add new',
    'profile.phone': 'Phone',
    'profile.birth-day': 'Birthday',
    'profile.btn-update': 'Update',
    'pages.responsibilities': 'Specialize',
    'menu.contact': 'Social',

    /* 03.User Login, Logout, Register */
    'user.login-title': 'Sign in',
    'user.register': 'Sign up',
    'user.forgot-password': 'Forgot password',
    'user.username': 'Username',
    'user.email': 'Email',
    'user.phone': 'Phone',
    'user.password': 'Password',
    'user.re-password': 'rePassword',
    'user.forgot-password-question': 'Forgot password?',
    'user.reset-password-button': 'Receive new code',
    'user.reset-password-button-submit': 'Change password',
    'user.fullname': 'Fullname',
    'user.login-button': 'Login',
    'user.register-button': 'Register',
    'user.code': 'Code',

    /* 04.Menu */
    'menu.partner': 'Personal',
    'menu.money': 'Finance',
    'menu.m': 'Product',
    'menu.warehouse': 'Inventory',
    'menu.invoice': 'Invoice',
    'menu.order': 'Invoice',
    'menu.app': 'Home',
    'menu.dashboards': 'Home',
    'menu.calendars': 'Calendar',
    'menu.analytics': 'Analytics',
    'menu.faq': 'FAQ',
    'menu.view': 'Question & Anwser',
    'menu.default': 'Tổng quát',
    'menu.content': 'Content',
    'menu.product': 'Product',
    'menu.menu': 'Product',
    'menu.pages': 'Manager',
    'menu.thumb-list': 'Manager product',
    // 'menu.order': 'Order',
    'menu.search': 'Search',
    'menu.login': 'Login',
    'menu.register': 'Register',
    'menu.company': 'Information of store',
    'menu.profile': 'Information',
    'menu.forgot-password': 'Change password',
    'menu.applications': 'Account',
    'menu.promotion': 'Promotion',
    'menu.todo': 'Event',
    'menu.category': 'Type product',
    'menu.ui': 'UI',
    'menu.table-setting': 'Table chair',
    'menu.stock': 'Stock',
    'menu.warehouse-import': 'Receipt',
    'menu.warehouse-export': 'Phiếu xuất kho',
    'menu.warehouse-transfer': 'Delivery bill',
    'menu.make-product': 'Quantitative',
    'menu.payment': 'Payment waiting table',
    'menu.table-pending-payment': 'Pending Payment',
    'menu.message': 'Message',
    'menu.ref': 'Affiliate',
    'menu.upgrade': 'Upgrade',
    'menu.setting': 'Setting',
    'menu.root': 'VMASS',
    'menu.user-staff': 'Staff',
    'menu.customer': 'Customer',
    'menu.company-provider': 'supplier',
    'menu.treasury': 'Treasury',
    'menu.income': 'Income',
    'menu.outcome': 'Outcome',
    'menu.role': 'Create permission',
    'menu.form-dynamic': 'Customize Form',
    'menu.user-role': 'Create account',
    'menu.qrcode': 'Qr Code',
    'menu.companies': 'Link stores together',

    /* 05.Dashboards */
    'dashboards.pending-orders': 'Receive Orders',
    'dashboards.completed-orders': 'Completed Orders',
    'dashboards.refund-requests': 'Refund Orders',
    'dashboards.sales': 'Nhận',
    'dashboards.sales-chart': 'Sales Chart',
    'dashboards.orders': 'delivered',
    'dashboards.refunds': 'Out of stock',
    'dashboards.calendar': 'Calendar',
    'dashboards.best-sellers': 'List of sold products',
    'dashboards.this-week': 'Week',
    'dashboards.this-month': 'Month',
    'dashboards.this-all-sales': 'All revenue',
    'dashboards.recent-orders': 'Recent Orders',
    'dashboards.stock-status': 'Stock status',
    'dashboards.logs': 'Logs',
    'dashboards.message': 'Message',
    'dashboards.area': 'Area',
    'dashboards.status-order': 'Summary of order status',
    'dashboards.pending-order': 'List of products not yet received',
    'dashboards.order-undelivery': 'List of undelivered products',
    'dashboards.order-pending-payment':
        'List of tables not yet collected payment',
    'dashboards.total-order': 'Total number of products ordered',
    'dashboards.product-not-receive': 'product not yet receive',
    'dashboards.product-not-delivery': 'product not yet delivery',
    'dashboards.table-notyet-pay': 'tables not yet collected payment',
    'dashboards.product-received-full': 'All products have been received',
    'dashboards.total-product-received': 'Total products received',
    'dashboards.product-delivery-full': 'All products have been delivered',
    'dashboards.total-table-has-customer':
        'Total table with guests during the day',
    'dashboards.table-payment-full': 'The tables have been fully paid',
    'dashboards.list-empty': 'List empty',
    'dashboards.total': 'Total',
    'dashboards.counter': 'Counter',
    'dashboards.table': 'Table',
    'dashboards.ice': 'Ice',
    'dashboards.sugar': 'Sweetness',
    'dashboards.all': 'ALL',
    'dashboards.completed': 'COMPLETED',
    'dashboards.destroy': 'DESTROY',
    'dashboards-empty-product': 'There are no products in the list yet',

    /** Analytics */
    'analytics.dashboards': 'Tổng quát',
    'analytics.user-staff': 'Staff',
    'analytics.customer': 'Customer',
    'analytics.company-provider': 'Supplier',
    'analytics.treasury': 'Treasury',
    'analytics.income': 'Income',
    'analytics.outcome': 'Outcome',
    'analytics.role': 'Create permission',
    'analytics.user-role': 'Create account',
    'analytics.form-dynamic': 'Customize Form',
    'analytics.companies': 'Link stores together',
    'analytics.dashboards.outcome': 'COST STATISTICS',
    'analytics.dashboards.income': 'REVENUE STATISTICS',
    'analytics.dashboards.stock-log': 'STATISTICS OF IMPORTED STOCKS',
    'analytics.dashboards.order-payment': 'STATISTICS LIST OF SOLD PRODUCTS',
    'analytics.dashboards.debt': 'DEBT STATISTICS',
    'analytics.dashboards.make-product': 'STATISTICS OF STOCKS USED',
    'analytics.dashboards.order-table': 'STATISTICS OF TABLE',
    'analytics.today': 'Today',
    'analytics.yesterday': 'Yesterday',
    'analytics.7-days-ago': '7 days ago',
    'analytics.this-week': 'This week',
    'analytics.last-week': 'Last week',
    'analytics.30-days-ago': '30-days ago',
    'analytics.this-month': 'This month',
    'analytics.last-month': 'Last month',
    'analytics.all': 'All',
    'analytics.compare': 'Compare',
    // 'analytics.update': 'Update',
    'analytics.revenue': 'Revenue',
    'analytics.costs': 'Fixed Costs',
    'analytics.profit': 'Profit',
    'analytics.invoice-quantity': 'Invoice quantity',
    'analytics.number-products-sold': 'Number of products sold',
    'analytics.average-selling-price': 'Average selling price',
    'analytics.total-product': 'Total product',
    'analytics.product': 'Product',
    'analytics.amount-of-inventory': 'Amount of inventory',
    'analytics.items': 'Items',
    'analytics.inventory-value': 'Inventory value',

    /* 06.Product */
    'pages.add-new': 'ADD NEW',
    'pages.add-new-user-staff': 'ADD NEW STAFF',
    'pages.add-new-log': 'ADD ANOTHER',
    'pages.order-new': 'ORDER',
    'pages.image': 'Image product',
    'pages.add-new-modal-title': 'Add product',
    'pages.order-new-modal-title': 'Order new product',
    'pages.update-modal-title': 'Update product',
    'pages.display-options': 'Show options',
    'pages.orderby': 'Sort: ',
    'pages.product-name': 'Product name',
    'pages.product-barcode': 'Barcode',
    'pages.product-sku': 'Mã sản phẩm',
    'pages.category': 'Type product',
    'pages.description': 'Description',
    'pages.status': 'Status',
    'pages.cancel': 'Cancel',
    'pages.submit': 'Submit',
    'pages.delete': 'Delete',
    'pages.delete-forever': 'Delete Forever',
    'pages.another-action': 'Another action',
    'pages.update': 'Update',
    'pages.price': 'Price',
    'pages.select-category': 'Select 1 type product',
    'pages.select-product': 'Select 1 product',
    'pages.order-number': 'Weight',
    'pages.no-selected': 'None action',
    'pages.order-more': 'Add product',
    'pages.total-order-price': 'Total price',
    'pages.current-order-price': 'Current order price',
    'pages.error-title': 'Ooop... some error!',
    'pages.error-code': 'Error',
    'pages.go-back-home': 'Go back home',
    'pages.softhide': 'Softhide product',
    'pages.un-softhide': 'Unsofthide product',
    'pages.bestter': 'Recomend using',
    'pages.un-bestter': 'Off - Recomend using',
    'pages.print-tem': 'In tem',
    'product.title': 'IInformation product',
    'product.price.original': 'Price',
    'product.price.sale': 'Promotional price',
    'product.price.cost': 'Giá vốn',
    'product.quantity': 'Số lượng',
    'product.inventory': 'Tồn kho',
    'product.ice': 'Amount of ice',
    'product.sugar': 'Sweetness',
    'product.size': 'Size',
    'product.topping': 'Topping',
    'product.add.name': 'Name',
    'product.add.value': 'Extra money',
    'product.add_price': 'Extra price',
    'product.update_cost': 'Update cost',
    'product.edit_cost': 'Edit cost',
    'product.search': 'Search name of product',
    'product.btn-add': 'Add product',

    /* 07.Category */
    'category.add-new-modal-title': 'Add type of product',
    'category.update-title': 'Update category of product',
    'category.title': 'Name product',
    'category.thumb-list': 'Type of product',
    'category.nav-tab': 'CATEGORY',
    'category.add-new-category': 'ADD CATEGORY',
    'category.btn-add': 'Add category',

    /* 08.Todo */
    'todo.add-new': 'Add new',
    'todo.thumb-list': 'Event',
    'todo.add-new-modal-title': 'Add new event',
    'todo.update-modal-title': 'Update event',
    'todo.title': 'Title of event',
    'todo.description': 'Description',
    'todo.date': 'Date',
    'todo.time': 'Time',
    'todo.update-done': 'Done',
    'todo.update-pending': 'Pending',
    'todo.delete': 'Delete',
    'todo.no-selected': 'None action',
    'todo.update': 'Update',
    'todo.date-time': 'Time',
    'todo.orderby': 'Sort: ',
    'todo.btn-add': 'Add event',

    /*table setting */
    'table-setting.row': 'Row',
    'table-setting.col': 'Column',
    'table-setting.floor': 'Area',
    'table-setting.btn-generate': 'Tạo bàn',
    'table-setting.map': 'Map',
    'table-setting.btn-save': 'Save',
    'table-setting.title': 'Setting table and chair model',

    /* stock */
    'stock.thumb-list': 'Stocks',
    'stock.add-new-modal-title': 'Add stock',
    'stock.name': 'Name stock',
    'stock.unit': 'Unit',
    'stock.unit-price': 'Purchase price',
    'stock.unit-price-update': 'Purchase price',
    'stock.unit-price-new': 'New Purchase price',
    'stock.price': 'Into money',
    'stock.count': 'Quantity',
    'stock.count-new': 'Quantity',
    'stock.delete': 'Delete Stock',
    'stock.reset': 'Reset to 0',
    'stock.count-update': 'Update stock',
    'stock.count-edit': 'Edit stock',
    'stock.count-current': 'Remaining',
    'stock.count-total': 'Total import',
    'stock.update-title': 'Update more stock',
    'stock.search': 'Search name of stock',
    'stock.btn-add': 'Add stock',

    /* warehouse */
    'warehouse.add-new-modal-title': 'Add new',
    'warehouse.phone': 'Phone',
    'warehouse.address': 'Address',
    'warehouse.code': 'Code stock',
    'warehouse.unit': 'Unit',
    'warehouse.description': 'Description',
    'warehouse.btn-add': 'Add',

    'warehouse.import-search': 'Search name of Receipt',
    'warehouse.import': 'Receipt',
    'warehouse.import-stock': 'Imported item',
    'warehouse.import-title': 'Update receipt',
    'warehouse.import-name': 'Name of person entering the warehouse',
    'warehouse.import-quantity': 'Quantity',
    'warehouse.import-price': 'Price import',
    'warehouse.btn-add-import': 'Create',

    'warehouse.export-search': 'Search name of Delivery bill',
    'warehouse.export': 'Delivery bill',
    'warehouse.export-stock': 'Export item',
    'warehouse.export-title': 'Update Delivery bill',
    'warehouse.export-name': 'Name of the person releasing the warehouse',
    'warehouse.export-quantity': 'Quantity',
    'warehouse.export-price': 'Price export',
    'warehouse.btn-add-export': 'Create',

    'warehouse.transfer-search': 'Search name of Warehouse transfer note',
    'warehouse.transfer': 'Warehouse transfer note',
    'warehouse.transfer-stock': 'Transfer item',
    'warehouse.transfer-title': 'Update Warehouse transfer note',
    'warehouse.transfer-name': 'Name of person transferring the warehouse',
    'warehouse.transfer-quantity': 'Quantity',
    'warehouse.transfer-price': 'Price transfer',
    'warehouse.transfer-name-carrier': 'Name of carrier',
    'warehouse.transfer-phone-carrier': 'Phone of carrier',
    'warehouse.transfer-receiving-warehouse': 'Move to warehouse',
    'warehouse.transportation': 'Transportation',
    'warehouse.cost-transfer': 'Transport fee',
    'warehouse.btn-add-transfer': 'Create',

    /* make product */
    'make-product.thumb-list': 'Quantitative',
    'make-product.add-new-modal-title': 'Add new Quantitative',
    'make-product.name': 'Name',
    'make-product.unit': 'Unit',
    'make-product.count': 'Quantity',
    'make-product.make-more': 'Add',
    'make-product.product-name': 'Name product',
    'make-product.stock-name': 'Name stock',
    'make-product.select-stock': 'Select 1 stock',
    'make-product.add-modal-title': 'Add new',
    'make-product.update-modal-title': 'Edit',
    'make-product.number-product-used': 'Number of stocks used',
    'make-product.price': 'Price',
    'make-product.cost': 'Price cost',
    'make-product.percent-cost': 'Percentage of cost/selling price',
    'make-product.btn-add': 'Create',

    /* FAQ */
    'faq.title': 'Hướng dẫn',
    'faq.text-title': 'Câu hỏi',
    'faq.text-content': 'Trả lời',
    'faq.modal-title': 'Câu hỏi và Trả lời',

    /** Ref */
    'ref.name': 'Name of the owner',
    'ref.companyName': 'Store name',
    'ref.email': 'Email',
    'ref.phone': 'Phone',
    'ref.address': 'Address',
    'ref.content': 'Message',
    'ref.title': 'Referred person information',
    'ref.sub-title':
        "Your referral commission is currently 30% of the referral's contract amount signed with VMASS. Your information will be automatically sent to VMASS based on the personal information you have provided.",
    'ref.btn-submit': 'Send',

    /** Chat */
    'chat.messages': 'Message',
    'chat.messages-inbox': 'Inbox',
    'chat.messages-new': 'Phonebook',
    'chat.start-conversation': 'Start a conversation!',

    /** Discount */
    'discount.add-new-modal-title': 'Add discount',
    'discount.note': 'Note',
    'discount.type': 'Type discount',
    'discount.value': 'Value discount',
    'discount.user': 'Staff',
    'discount.products': 'Product',
    'discount.select-all-products': 'All product',
    'discount.select-one-type': 'Select type value',
    'discount.select-one-product': 'Select 1 product',
    'discount.select-one-type-product': 'Select 1 type product',
    'discount.to-bill': 'Add another',
    'discount.add-feetax': 'Add Discount, Tax, Fee',
    'discount.discount': 'Discount',
    'discount.tax': 'Tax',
    'discount.fee-other': 'Fee-other',

    /** Customer */
    'customer.add-new-modal-title': 'Add new',
    'customer.title': 'Information',
    'customer.name': 'Name',
    'customer.phone': 'Phone',
    'customer.email': 'Email',
    'customer.address': 'Address',
    'customer.point': 'Point',
    'customer.armorial': 'Armorial',
    'customer.used-item': 'Number of uses',
    'customer.tags': 'Tags',
    'customer.info': 'INFO',
    'customer.used': 'USED PRODUCTS',
    'customer.setting': 'SETTING',
    'customer.search': 'Find by phone',
    'customer.btn-add': 'Create',
    'customer.amount-spent': 'Amount Spent',
    'customer.debt': 'Debt',

    /** Income, Outcome, Treasury */
    action: 'Action',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    price: 'Price',
    note: 'Description',
    time: 'Statistical',
    'time-created': 'Time created',
    'user.created': 'User created',
    'select-one-time': 'Choose one type',
    'select-one-time-discount': 'Choose 1 type discount',
    'select-one-time-gift': 'Choose 1 type gift',

    'income.title': 'Income',
    'income.sub_title': 'Title',
    'income.add-new-modal-title': 'Add new Income',
    'income.name': 'Name of submitter',
    'income.search': 'Search by name income',
    'income.btn-add': 'Create',

    'outcome.title': 'Outcome',
    'outcome.sub_title': 'Title',
    'outcome.add-new-modal-title': 'Add new Outcome',
    'outcome.name': "Recipient's name",
    'outcome.search': 'Search by name outcome',
    'outcome.btn-add': 'Create',

    'treasury.name': 'Name treasury',
    'treasury.title': 'Treasury',
    'treasury.add-new-modal-title': 'Add new treasury',
    'treasury.timeCreated': 'Time created',
    'treasury.search': 'Search by name treasury',
    'treasury.btn-add': 'Create',

    /** Break Event */
    'breakeven.title': 'Breakeven',

    /** Company Provider */
    'company-provider.title': 'Supplier',
    'company-provider.title-log': 'Add transaction',
    'company-provider.title-log-add': 'Add transaction',
    'company-provider.title-log-add-more': 'Additional payment',
    'company-provider.add-new-modal-title': 'Add new Supplier',
    'company-provider.name': 'Name',
    'company-provider.item_name': 'Items',
    'company-provider.total_price_income': 'Total amount entered',
    'company-provider.total_price_outcome': 'Paid',
    'company-provider.total_price_pending': 'Remaining',
    'company-provider.price': 'Price',
    'company-provider.item_product': 'Supplied items',
    // 'company-provider.name': 'Name of supplier',
    'company-provider.search': 'Search by name supplier',
    'company-provider.btn-add': 'Create',

    /** User Staff */
    'user-staff.title': 'Information Staff',
    'user-staff.add-new-modal-title': 'Add new',
    'user-staff.add-new-logs-modal-title': 'Add another',
    // 'user-staff.title': 'Staff',
    'user-staff.permission_name': 'Job position',
    'user-staff.date_join': 'Date join',
    'user-staff.date_get_salary': 'Salary payment date',
    'user-staff.hour_working_on_day': 'Number of working hours per day',
    'user-staff.status_working': 'Work status',
    'user-staff.salary_by': 'Calculate salary accordingly',
    'user-staff.salary_value': 'Wage',
    'user-staff.working_hours': 'Work time',
    'user-staff.current_commission': 'Commission',
    'user-staff.current_bonus': 'Bonus',
    'user-staff.current_overtime': 'Overtime money',
    'user-staff.current_advence': 'Advance money',
    'user-staff.current_fined': 'Fine',
    'user-staff.current_dayoff': 'Leave money',
    'user-staff.current_day_working': 'Workday this month',
    'user-staff.current_salary': 'Salary this month',
    'user-staff.total_salary': 'Total salary',
    'user-staff.total_day_working': 'Total workday',
    'user-staff.working_hours_from': '* Work from',
    'user-staff.working_hours_to': '* Work to',
    'user-staff.logs_users_staff': 'Name',
    'user-staff.logs_type': 'Type',
    'user-staff.logs_value_salary': 'Amount of money',
    'user-staff.logs_value_hour': 'Hour',
    'user-staff.overtime_coefficient': 'Overtime salary coefficient',
    'user-staff.select-all-users': 'Choose staff',
    'user-staff.select-one': 'Choose 1 type',
    'user-staff.name': 'Name',
    'user-staff.phone': 'Phone',
    'user-staff.address': 'Address',
    'user-staff.email': 'Email',
    'user-staff.search': 'Search by name staff',
    'user-staff.btn-add': 'Create',

    /** Role */
    'role.name': 'Name Decentralization',
    'role.title': 'Decentralization',
    'role.add-new-modal-title': 'Add new',
    'role.btn-add': 'Create',

    /** User Role */
    'user-role.title': 'Edit Decentralization',
    'user-role.name': 'Name of staff',
    'user-role.add-new-modal-title': 'Add new',
    'user-role.select-one': 'Choose a permission',
    'user-role.place-holder-password': 'Leave blank if not changed',
    'user-role.btn-add': 'Create',

    /** Form Dynamic */
    'form-dynamic.title': 'Customize Forn',
    'form-dynamic.add-new-modal-title': 'Add new',
    'form-dynamic.label': 'Title',
    'form-dynamic.alias': 'Type form',
    'form-dynamic.select-one-alias': 'Choose 1 form',
    'form-dynamic.type': 'Datatypes',
    'form-dynamic.select-one-type': 'Choose 1 type',
    'form-dynamic.btn-add': 'Create',

    'url.placeholder': 'http:// or https://',

    /** Compananies */
    'companies.find-company-uuid': 'Find code of store',
    'companies.title': 'Link store together',
    'companies.add-new-modal-title': 'Add new',
    'companies.name': 'Name',
    'companies.type': 'Type',
    'companies.unset': 'None-link',
    'companies.btn-add': 'Create',

    /** Promotion */
    'promotion.thumb-list': 'Promotion',
    'promotion-add': 'Add new',
    'promotion-name': 'Name of promotion',
    'promotion-code': 'Code',
    'promotion-quantity': 'Applicable quantity',
    'promotion-description': 'Description',
    'promotion-date_start': 'Time start',
    'promotion-date_end': 'Time end',

    /** Calendar */
    'calendar.add-event': 'Add event',
};

export default enUs;
